import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import React, { Fragment } from 'react';

import { ContentSwitch, ConfirmModal, JobsImportedModal, ConfirmDelete, ResendMailConfirmationModel } from 'Components';
import { EXCEL_TO_SUBMISSION, JOBS_EXCEL, SUBMISSIONS, SUPPLIES, TEMPLATES } from 'constants/apis';
import { confirmJobsStatus } from 'helpers/confirmStatus';
import { equal } from 'helpers/deep';
import DownloadFromUrl from 'helpers/download';
import Fetch from 'helpers/fetch';
import { buildUrl } from 'helpers/misc';
import { handlePageNumberChange, handlePageSizeChange } from 'helpers/pagination';
import { cleanSearchParams, urlSearchToObject } from 'helpers/urlSearchParams';
import i18n from 'i18next';
import log from 'loglevel';
import PropTypes from 'prop-types';
import { getRegionData } from 'constants/regions';
import rowRules from 'helpers/rowRules';
import menuOptions from 'constants/menuOptions';
import JobsDesktop from './JobsDesktop/JobsDesktop';
import JobsMobile from './JobsMobile/JobsMobile';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';

class Jobs extends React.Component {
  //! Deletion Context:
  static contextType = DeletionContext;

  constructor(props) {
    super(props);

    const isFoodUser = props.userInfo.LOB === 'F';
    const isEnvironmentalUser = props.userInfo.LOB === 'E';
    const isInternalUser = props.userInfo.IsInternalUser;
    const isExternalUser = !props.userInfo.IsInternalUser;

    // TODO: Updating the rules for when the tab should be displayed should be added here once we have the logic for the external user.
    this.userAllowedSplitReportsAccess = isInternalUser;
    // this.userAllowedSplitReportsAccess = true;

    const searchValues = {
      Received: { Received: true },
      'Draft & Submitted': { Received: false },
      'Additional Analysis': {},
      'Split Reports': {},
    };

    this.sortDirections = {
      Received: '-ReceivedDate,-MaxxamJobNumber',
      'Draft & Submitted': '-ECoCNumber',
    };

    this.state = {
      powerTableIndex: null,
      powerTableCode: null,
      popoverRow: null,
      auditTrailItem: '',
      isAuditTrailItemShowing: false,
      // ! IF Food user, then remove the Additional Analysis tab:
      //* The new array created from the Object.keys() method will be the tabs that will be displayed, and here where the order of a tab location in the array determines the tab index number will be used in JobsDesktop.jsx to handle each tab's display: */
      tabs: isFoodUser
        ? Object.keys(searchValues).filter((tab) => {
            if (tab === 'Additional Analysis') {
              return false;
            }

            if (tab === 'Split Reports') {
              return this.userAllowedSplitReportsAccess;
            }

            return true;
          })
        : isEnvironmentalUser
        ? Object.keys(searchValues).filter((tab) => {
            if (tab === 'Split Reports') {
              return this.userAllowedSplitReportsAccess;
            }
            return true;
          })
        : Object.keys(searchValues).filter((tab) => {
            if (tab === 'Split Reports') {
              return this.userAllowedSplitReportsAccess;
            }
            return true;
          }),
      searchValues,
      globalSearchIndex: 0,
      globalSearchTabs: isFoodUser ? ['Jobs', 'Samples'] : ['Jobs', 'Samples', 'Additional Analysis'],
      isShowingImportedJobModal: false,
      itemToDelete: undefined,
      isShowDeleteConfirmation: false,

      itemToCancelIndex: undefined,
      cancelItemComments: '',

      isShowResendConfirmationModel: false,
      submissionId: 0,
      emailList: '',
      option:'',
    };

    this.handlePageSizeChange = handlePageSizeChange('jobs').bind(this);
    this.handlePageNumberChange = handlePageNumberChange('jobs').bind(this);
    this.onPaginationClick = this.onPaginationClick.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleSearchDownload = this.handleSearchDownload.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.popoverRef = React.createRef();
    this.onAuditCancel = this.onAuditCancel.bind(this);
    this.onAuditProceed = this.onAuditProceed.bind(this);
    this.setPageState = this.setPageState.bind(this);
    this.deleteSubmission = this.deleteSubmission.bind(this);
    this.deleteSelectedItems = this.deleteSelectedItems.bind(this);
    this.onResendEmailProcced = this.onResendEmailProcced.bind(this);

    this.handleResendModal = this.handleResendModal.bind(this);
    this.funcs = {
      onPaginationClick: this.onPaginationClick,
      handleTabClick: this.handleTabClick,
      setPageState: this.setPageState,
      onOptionClick: this.onOptionClick.bind(this),
      onPageSizeChange: this.handlePageSizeChange,
      onSearchDownload: this.handleSearchDownload,
      onUpload: this.handleUpload,
      onDelete: this.deleteSubmission,
      deleteSelectedItems: this.deleteSelectedItems,
    };
  }

  componentDidMount() {
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;

    this.handleSearch();
    this.props.setHeadTitle(i18n.t('head:Jobs'));

    this.dispatch({
      type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
      payload: {
        data: [],
        tableCode: this.props.data.code,
        idName: 'SubmissionId',
        selectedItems: [],
        itemsAllowedToDelete: [],
        isDeletionModeActive: false,
        isDeleteConfirmationActive: false,
      },
    });

    this.props.setAppState((prevState) => ({
      isNavCollapsed: true,
      jobs: {
        ...prevState.jobs,
        shouldLoad: true,
      },
    }));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !equal(nextProps, this.props) || !equal(nextState, this.state);
  }

  componentDidUpdate(prevProps) {
    this.handleSearch(prevProps);
    const isSearching = Object.keys(urlSearchToObject(this.props.location.search)).length > 0;

    if (isSearching) {
      this.props.setHeadTitle(i18n.t('head:JobsSearch'));
      return;
    }

    if (this.props.location !== prevProps.location || prevProps.filterItemValue !== this.props.filterItemValue) {
      this.props.setHeadTitle(i18n.t('head:Jobs'));
    }

    const isSearch = this.props.location.search.includes('searchType');
    const wasSearch = prevProps.location.search.includes('searchType');

    if (!isSearch && wasSearch) {
      this.setState({ globalSearchIndex: 0 });
    }

    if (!this.props.data.isLoading && prevProps.data.isLoading) {
      this.dispatch({
        type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
        payload: {
          data: this.props.data.data,
        },
      });
      this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });
    }
  }

  componentWillUnmount() {
    this.props.data.abortController.abort();
    this.props.samples.abortController.abort();

    this.props.setAppState((prevState) => ({
      isNavCollapsed: false,
      jobs: {
        ...prevState.jobs,
        abortController: new AbortController(),
      },
      samples: {
        ...prevState.samples,
        abortController: new AbortController(),
      },
    }));

    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;
    this.dispatch({ type: DELETE_ACTIONS.RESET_DELETION_STATE });
  }

  onPaginationClick(pageNumber) {
    if (this.state.globalSearchIndex === 0) {
      return this.handlePageNumberChange(pageNumber);
    }

    return this.props.setAppState({
      samples: {
        ...this.props.samples,
        shouldLoad: true,
        pageNumber,
      },
    });
  }

  handleResendModal() {
    this.setState({
      processing: false,
      isShowResendConfirmationModel: false,
      submissionId: 0,
      emailList: '',
      option:'',
    });
  }

  onResendEmailProcced(emailList) {
    let URL;
    if (this.state.option === 'request') {
      URL = `${SUBMISSIONS}/${this.state.submissionId}/PaymentLink?region=${localStorage.getItem(
        'Region',
      )}&resendEmailList=${emailList}`;
    } else if (this.state.option === 'receipt') {
      URL = `${SUBMISSIONS}/${this.state.submissionId}/PaymentReceipt?resendEmailList=${emailList}`;
    }
    this.handleResendModal();
    Fetch.Get(URL)
      .then((response) => {
        console.log('email has been sent');
      })
      .catch(({ err }) => {
        log.error(err);
      });
  }

  onOptionClick(code, i, isSample = false) {
    const { dispatch } = this.context;

    const item = isSample ? this.props.samples.data[i] : this.props.data.data[i];
    const isJob = !!item.MaxxamJobNumber && !isSample;
    const copyBody = isJob ? { CopyMaxxamJobNumber: item.MaxxamJobNumber } : { CopySubmissionId: item.SubmissionId };

    this.setState({ powerTableIndex: null });

    if (code === 'view' && !isJob && !isSample) {
      confirmJobsStatus(item)
        .then(() => {
          if (item.RequestStatus !== 'D') {
            this.props.setAppState({ formIndex: 5 });
          } else if (item.Status === 'S') {
            this.props.setAppState({ formIndex: 4 });
          } else {
            this.props.setAppState({ formIndex: 2 });
          }

          this.props.history.push(`/submissions/${encodeURIComponent(item.SubmissionId)}/edit`);
        })
        .catch(() => this.refreshTable());
    } else if (code === 'view' && isJob && !isSample && item.Status == '2' && item.IsPrepaidJob) {
      this.props.setAppState({ formIndex: 5 });
      this.props.history.push(`/submissions/${encodeURIComponent(item.SubmissionId)}/edit`);
    } else if (code === 'view' && isJob && !isSample) {
      this.props.history.push(`/jobs/${encodeURIComponent(item.MaxxamJobNumber)}`);
    } else if (code === 'view' && isSample) {
      this.props.history.push(
        `/jobs/${encodeURIComponent(item.JobNumber)}?${(this.props.samples.data[i] || {}).SampleNumber}`,
      );
    } else if (code === 'edit' && !isJob) {
      confirmJobsStatus(item)
        .then(() => {
          if (item.Status === 'S' || item.Status === 'E' || item.Status === 'C') {
            this.setState({
              auditTrailItem: item,
              isAuditTrailItemShowing: true,
            });
          } else {
            this.props.setAppState({ formIndex: 0 });
            this.props.history.push(`/submissions/${encodeURIComponent(item.SubmissionId)}/edit`);
          }
        })
        .catch(() => this.refreshTable());
    } else if (code === 'newTemplate') {
      this.props.setAppState({ isCreatingObject: true });

      Fetch.Post(TEMPLATES, copyBody)
        .then((data) => data.json())
        .then((json) => this.props.history.push(`/templates/${json.DataItem.Id}/edit`))
        .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0 }))
        .catch(({ response }) => this.props.onAPIError(response, true))
        .finally(() => this.props.setAppState({ isCreatingObject: false }));
    } else if (code === 'newSubmission') {
      this.props.setAppState({ isCreatingObject: true });
      const url = isJob ? `${SUBMISSIONS}/Job/${item.MaxxamJobNumber}` :
        `${SUBMISSIONS}/submission/${item.SubmissionId}`;
      Fetch.Post(url)
        .then((data) => data.json())
        .then((json) => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
        .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0 }))
        .catch(({ response }) => this.props.onAPIError(response, true))
        .finally(() => this.props.setAppState({ isCreatingObject: false }));
    } else if (code === 'newOrder') {
      this.props.setAppState({ isCreatingObject: true });
      if (this.props.isPrepaid) {
        const url = isJob ? `${SUBMISSIONS}/Job/${item.MaxxamJobNumber}?requireOrder=true` :
          `${SUBMISSIONS}/submission/${item.SubmissionId}?requireOrder=true`;
        Fetch.Post(url)
          .then((data) => data.json())
          .then((json) => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
          .then(() => this.props.setAppState({ isCreatingObject: false, isPrepaidOrder:true, formIndex: 0 }))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
      }
      else {
        Fetch.Post(SUPPLIES, copyBody)
          .then((data) => data.json())
          .then((json) => this.props.history.push(`/supplies/${json.DataItem.OrderNumber}/edit`))
          .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0 }))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
      }
    } else if (code === 'multiDelete' && !isJob) {
      dispatch({
        type: DELETE_ACTIONS.ACTIVATE_DELETION_MODE,
        payload: { id: item.SubmissionId },
      });
    } else if (code === 'delete' && !isJob) {
      confirmJobsStatus(item)
        .then(() => {
          if (item.Status === 'D' || item.Status === 'C') {
            this.setState({
              itemToDelete: item,
              isShowDeleteConfirmation: true,
            });
          }
        })
        .catch(() => this.refreshTable());
    } else if (code === 'cancel') {
      if (this.state.itemToCancelIndex !== undefined || item.IsPrepaidJob) {
        confirmJobsStatus(item)
          .then(() => {
            this.props.setAppState({ isChangingObject: true });
            this.setState({ itemToCancelIndex: undefined });
            console.log(this.state.cancelItemComments);
            Fetch.Put(`${SUBMISSIONS}/${item.SubmissionId}/Cancel`, 
             this.state.cancelItemComments
            ).then(() => {
              this.setState({ cancelItemComments: '' });
              this.props.setAppState((prevState) => ({
                isChangingObject: false,
                jobs: {
                  ...prevState.jobs,
                  shouldLoad: true,
                },
              }));
            });
          })
          .catch(() => this.refreshTable());
      } else {
        this.setState({ itemToCancelIndex: i, cancelItemComments: '' });
      }
    } else if (code === 'share') {
      if (isJob) {
        this.props.setAppState({
          shareId: item.MaxxamJobNumber,
          shareCode: 'Job',
        });
      } else {
        this.props.setAppState({
          shareId: item.SubmissionId,
          shareCode: 'Submission',
        });
      }
    } else if (code === 'trackingForm') {
      DownloadFromUrl(`${SUBMISSIONS}/${item.SubmissionId}/GetPhysicalTrackingForm`).catch(({ response }) =>
        this.props.onAPIError(response, true),
      );
    } else if (code === 'submissionSummary') {
      DownloadFromUrl(`${SUBMISSIONS}/${item.SubmissionId}/GetGenericPDF?SummaryFormat=true`).catch(({ response }) =>
        this.props.onAPIError(response, true),
      );
    } else if (code === 'submissionDetails') {
      DownloadFromUrl(`${SUBMISSIONS}/${item.SubmissionId}/GetGenericPDF?SummaryFormat=false`).catch(({ response }) =>
        this.props.onAPIError(response, true),
      );
    } else if (code === 'addTest') {
      this.props.history.push(`/jobs/${encodeURIComponent(item.MaxxamJobNumber)}?addTestModalOpen=true`);
    } else if (code === 'request') {
      this.setState({
        processing: true,
        isShowResendConfirmationModel: true,
        submissionId: item.SubmissionId,
        emailList: item.ContactEmail,
        option: code,
      });
    } else if (code === 'receipt') {
      this.setState({
        processing: true,
        isShowResendConfirmationModel: true,
        submissionId: item.SubmissionId,
        emailList: item.ContactEmail,
        option: code,
      });
    } else if (code === 'paynow') {
      this.setState({ processing: true });
      confirmJobsStatus(item)
        .then(() => {
          Fetch.Get(`${SUBMISSIONS}/${item.SubmissionId}/PayNow?region=${localStorage.getItem('Region')}`)
            .then((response) => response.json())
            .then((data) => {
              if (data.Message.includes('&PrefixInvoiceNumber')) {
                window.open(`${window.location.origin}/PayInvoice?${data.Message}`, '_blank', 'noreferrer');
              }
            });
        })
        .catch(() => this.refreshTable());
    }
  }

  onAuditCancel() {
    this.setState({
      auditTrailItem: undefined,
      isAuditTrailItemShowing: false,
    });
    this.props.setAppState({ ChangeLogComments: undefined });
  }

  onAuditProceed() {
    const Id = this.state.auditTrailItem.SubmissionId;
    this.setState({ isAuditTrailItemShowing: false }, () =>
      this.props.setAppState({ isChangingObject: true }),
    );

    Fetch.Put(`${SUBMISSIONS}/${Id}/Edit`)
      .then(() => this.props.history.push(`/submissions/${Id}/edit`))
      .then(() =>
        this.props.setAppState((prevState) => ({
          isChangingObject: false,
          formIndex: 0,
          ChangeLogComments: prevState.ChangeLogComments === undefined ? '' : prevState.ChangeLogComments,
        })),
      );
  }

  setPageState(state, callback) {
    if (Number.isInteger(state.powerTableIndex) && state.powerTableViewCode !== undefined) {
      if ((this.props.data.data[state.powerTableIndex] || {}).Status === 'I') {
        this.setState({ isShowingImportedJobModal: true });
      } else {
        this.setState(state, callback);
      }
    } else {
      this.setState(state, callback);
    }
  }

  refreshTable() {
    this.props.setAppState((prevState) => ({
      jobs: {
        ...prevState.jobs,
        shouldLoad: true,
      },
    }));
  }

  handleSearch(prevProps) {
    const isSearch = this.props.location.search.includes('searchType');
    const { searchType, ...globalSearchParams } = cleanSearchParams(urlSearchToObject(this.props.location.search));

    if (!equal(this.props.data.globalSearchParams, globalSearchParams)) {
      this.props.setAppState((prevState) => ({
        jobs: {
          ...prevState.jobs,
          shouldLoad: true,
          pageNumber: 1,
          globalSearchParams,
          tabIndex: 0,
        },
        samples: {
          ...prevState.samples,
          shouldLoad: true,
          pageNumber: 1,
          globalSearchParams,
        },
      }));

      const { globalSearchIndex: searchGlobalSearchIndex } = urlSearchToObject(this.props.location.search);
      this.setState({
        globalSearchIndex: Number(searchGlobalSearchIndex) || 0,
      });
    }

    if (prevProps !== undefined) {
      const wasSearch = prevProps.location.search.includes('searchType');
      if (wasSearch && !isSearch) {
        this.setState({
          globalSearchIndex: 0,
          globalSearchSamples: {
            shouldLoad: true,
            data: [],
          },
        });
      }
    }
  }

  async handleUpload(e) {
    this.props.setAppState({
      isGlobalLoaderShowing: true,
    });
    const body = new FormData();
    body.append('file', e.target.files[0]);

    await Fetch.HydrateIdentityToken();
    const { apiURL } = getRegionData(localStorage.getItem('Region'));

    fetch(`${apiURL}/${EXCEL_TO_SUBMISSION}`, {
      method: 'POST',
      headers: {
        mimeType: 'multipart/form-data',
        IdentityToken: window.localStorage.getItem('IdentityToken'),
        RefreshToken: window.localStorage.getItem('RefreshToken'),
      },
      body,
    })
      .then((response) => {
        if (response.status >= 300) {
          throw new Error({ response });
        } else {
          return response.json();
        }
      })
      .then((data) => {
        this.props.setAppState(
          {
            isGlobalLoaderShowing: false,
          },
          () => this.props.history.push(`/submissions/${data.DataItem}/edit`),
        );
      })
      .catch(({ response }) => this.props.onAPIError(response, true))
      .finally(() => this.props.setAppState({ isGlobalLoaderShowing: false }));
  }

  deleteSubmission(item) {
    this.setState({
      isShowDeleteConfirmation: false,
      itemToDelete: undefined,
      powerTableIndex: null,
      popoverRow: null,
    });

    this.props.setAppState((prevState) => ({
      jobs: {
        ...prevState.jobs,
        isDeleting: true,
      },
      isGlobalLoaderShowing: true,
    }));

    Fetch.Delete(SUBMISSIONS, { IdList: [item.SubmissionId] })
      .then(() => {
        this.props.setAppState((prevState) => ({
          jobs: {
            ...prevState.jobs,
            shouldLoad: true,
          },
        }));
      })
      .catch(({ response }) => this.props.onAPIError(response, true))
      .finally(() => {
        this.props.setAppState((prevState) => ({
          jobs: {
            ...prevState.jobs,
            isDeleting: false,
          },
          isGlobalLoaderShowing: false,
        }));
      });
  }

  deleteSelectedItems(selectedItemsForDeletion) {
    const { dispatch } = this.context;

    this.setState({
      isShowDeleteConfirmation: false,
      itemToDelete: undefined,
      powerTableIndex: null,
      popoverRow: null,
    });

    this.props.setAppState((prevState) => ({
      jobs: {
        ...prevState.jobs,
        isDeleting: true,
      },
      isGlobalLoaderShowing: true,
    }));

    Fetch.Delete(SUBMISSIONS, { IdList: selectedItemsForDeletion })
      .then(() => {
        this.props.setAppState((prevState) => ({
          jobs: {
            ...prevState.jobs,
            shouldLoad: true,
          },
        }));
        dispatch({ type: DELETE_ACTIONS.SUCCESSFUL_DELETION });
      })
      .catch(({ response }) => this.props.onAPIError(response, true))
      .finally(() => {
        this.props.setAppState((prevState) => ({
          jobs: {
            ...prevState.jobs,
            isDeleting: false,
          },
          isGlobalLoaderShowing: false,
        }));
      });
  }

  handleTabClick(tabIndex) {
    const { searchValues, tabs } = this.state;

    const searchParams = searchValues[tabs[tabIndex]];
    const sort = this.sortDirections[tabs[tabIndex]];

    if (tabIndex === 2) {
      this.props.setAppState((prevState) => {
        this.dispatch({
          type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
          payload: {
            data: this.props.data.data,
            idName: 'SubmissionId',
            tableCode: this.props.data.code,
            selectedItems: [],
            isDeletionModeActive: false,
          },
        });

        return {
          jobs: {
            ...prevState.jobs,
            tabIndex,
          },
        };
      });
    } else {
      this.props.setAppState((prevState) => {
        this.dispatch({
          type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
          payload: {
            data: this.props.data.data,
            idName: 'SubmissionId',
            tableCode: this.props.data.code,
            selectedItems: [],
            isDeletionModeActive: false,
          },
        });

        return {
          jobs: {
            ...prevState.jobs,
            searchParams,
            tabIndex,
            pageNumber: 1,
            sort,
            shouldLoad: this.props.data.tabIndex !== tabIndex,
          },
        };
      });
    }
  }

  handleSearchDownload() {
    const { searchType, ...globalSearchParams } = cleanSearchParams(urlSearchToObject(this.props.location.search));

    DownloadFromUrl(buildUrl(JOBS_EXCEL, globalSearchParams));
  }

  render() {
    const { state, props, funcs } = this;
    const sharedProps = {
      isGlobalSearch: this.props.location.search.includes('searchType'),
      popoverRef: this.popoverRef,
      globalSearch: urlSearchToObject(this.props.location.search),
      rowRules: rowRules.job,
      rowRulesSample: rowRules.sample,
      userAllowedSplitReportsAccess: this.userAllowedSplitReportsAccess,
      menuOptions,
    };

    return (
      <Fragment>
        <ContentSwitch index={props.deviceIndex} {...state} {...props} {...funcs} {...sharedProps}>
          <JobsMobile />
          <JobsDesktop />
        </ContentSwitch>
        {state.isShowingImportedJobModal && <JobsImportedModal setPageState={this.setPageState} />}
        {/* Edit Audit Trail */}
        {state.auditTrailItem && state.isAuditTrailItemShowing && (
          <ConfirmModal
            onChange={(e) => props.setAppState({ ChangeLogComments: e.target.value })}
            value={props.ChangeLogComments}
            description={i18n.t('confirmModal:edit')}
            cancelReasonText={i18n.t('confirmModal:reason')}
            onCancelClick={this.onAuditCancel}
            onProceedClick={() => this.onAuditProceed(state.auditTrailItem)}
          />
        )}
        {/* Cancel ChangeLogComments */}
        {state.itemToCancelIndex !== undefined && (
          <ConfirmModal
            onChange={(e) => this.setState({ cancelItemComments: e.target.value })}
            value={state.cancelItemComments}
            description={i18n.t('confirmModal:cancel')}
            cancelReasonText={i18n.t('confirmModal:reason')}
            onCancelClick={() =>
              this.setState({
                cancelItemComments: '',
                itemToCancelIndex: undefined,
              })
            }
            onProceedClick={() => this.onOptionClick('cancel', this.state.itemToCancelIndex)}
          />
        )}
        {state.isShowDeleteConfirmation && (
          <ConfirmDelete
            title={`${i18n.t('common:Delete the')} ${i18n.t('common:Submission')}`}
            onCancelDelete={() =>
              this.setState({
                itemToDelete: undefined,
                isShowDeleteConfirmation: false,
              })
            }
            onProceedDelete={() => this.deleteSubmission(state.itemToDelete)}
          />
        )}
        {state.isShowResendConfirmationModel && (
          <ResendMailConfirmationModel
            onChange={(e) => this.setState({ emailList: Object.values(e).join(';') })}
            emailList={this.state.emailList}
            title={this.state.option }
            onProcced={this.onResendEmailProcced}
            onCancel={this.handleResendModal}
          />
        )}
      </Fragment>
    );
  }
}

Jobs.propTypes = {
  filterFieldValue: PropTypes.string,
  filterItemValue: PropTypes.string,
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    code: PropTypes.string,
    abortController: PropTypes.shape({}),
    shouldLoad: PropTypes.bool,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
    globalSearchParams: PropTypes.shape({}),
    tabIndex: PropTypes.number,
  }),
  samples: PropTypes.shape({
    abortController: PropTypes.shape({}),
    data: PropTypes.shape([]),
  }),
  setHeadTitle: PropTypes.func,
  setAppState: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  receivedJobs: PropTypes.shape({}),
  onAPIError: PropTypes.func,
  userInfo: PropTypes.shape({
    LOB: PropTypes.string,
  }),
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
};

export default Jobs;



// WEBPACK FOOTER //
// ./src/containers/Jobs/Jobs.jsx